<template>
  <div class="body" :style="'max-height:' +
    pageHeight +
    'px;max-width:' +
    pageWidth +
    'px;overflow: y;'
    ">
    <el-row>
      <el-col :span="18">
        <div class="product-left" :style="'height:' + leftHeight + 'px;'">
          <ListSearchToobar v-model="searchRquest" v-bind="searchToobarData" @search="init" />
          <div class="product_list" :style="'height:' + leftHeight + 'px;'">
            <ul>
              <li v-for="(item, index) in ProductList" :key="index" @click="ProductListClick(item, index)"
                :class="active == index ? 'isActive' : ''" style="position:relative;">
                <img v-if="item.dataUrl" :src="item.dataUrl" class="avatar product-img">
                <img v-else src="../../assets/img/Group-278.png" class="avatar product-img">
                <div class="erp_product_name" :title="item.name">{{ item.name }}</div>
                <div style="display: flex;width: 100%;justify-content: space-between;align-items: center;">
                  <el-tooltip :content="item.currency + ' ' + item.userMonthPrice + ' ' + $t('month')" placement="top"
                    effect="light">
                    <div class="erp_product_amount">
                      {{ item.currency + ' ' + item.userMonthPrice + ' ' + $t('month') }}
                    </div>
                  </el-tooltip>
                  <el-button round type="primary" size="mini" @click="trialButtonClick()" class="trial-button" style="">
                    {{ $t("apply_trial") }}
                  </el-button>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="product-right" :style="'height:' + pageHeight + 'px;'">
          <ul>
            <li>
              <span class="item-name">{{ itemErpProduct.name }}</span>
            </li>
            <li>
              <span class="item-code">{{ $t('price') }}</span>
              <span class="item-val">{{
                (itemErpProduct.currency || '') +
                ' ' +
                (itemErpProduct.userMonthPrice || '') +
                '\xa0' +
                $t('month')
                }}</span>
            </li>
            <li>
              <span class="item-code">{{ $t('description') }}</span>
            </li>
            <li>
              <span class="item-descriptioninfo" :style="'width:' + infoWidth + 'px;'"
                :title="this.$t(itemErpProduct.description)">{{ itemErpProduct.description }}</span>
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>
    <Footerbar style="padding-left: 0px !important;">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
        <div style="float: left">
          <el-popover popper-class="buyer-info" style="background-color: #f4f4f4" placement="top" trigger="click"
            width="328" @show="showPover" @hide="hidePover">
            <el-form-item :label="$t('first_name')" prop="firstName">
              <el-input v-model="form.firstName" :disabled="disabled" size="mini"></el-input>
            </el-form-item>
            <el-form-item :label="$t('last_name')" prop="lastName">
              <el-input v-model="form.lastName" :disabled="disabled" size="mini"></el-input>
            </el-form-item>
            <el-form-item :label="$t('email')" prop="email">
              <el-input v-model="form.email" :disabled="disabled" size="mini"></el-input>
            </el-form-item>
            <el-form-item :label="$t('cellphone')">
              <el-input v-model="form.cellphone" :disabled="disabled" size="mini"></el-input>
            </el-form-item>
            <el-form-item :label="$t('company')">
              <el-input v-model="form.company" size="mini"></el-input>
            </el-form-item>
            <el-button class="popover-but" slot="reference">{{ $t('buyer_info')
              }}<i class="el-icon--right" :class="ShowActive ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
                "></i></el-button>
          </el-popover>
        </div>
        <div style="float: left; margin-top: 10px">
          <el-form-item :label="$t('user_qty')" class="form-label" prop="userNumber">
            <el-input v-model.number="form.userNumber" @input="userqtyChange" placeholder="0" size="mini"
              style="width: 70px"></el-input>
          </el-form-item>
        </div>
        <div style="float:left;margin-top: 10px;margin-left: 20px;">
          <el-form-item :label="$t('payment')" label-width="140px" class="form-label" prop="creationMethod">
            <el-select v-model="form.creationMethod" size="mini" @change="creationMethodChange" placeholder=""
              style="width: 110px">
              <el-option v-for="item in paymentValueOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="float: left; margin-top: 10px; margin-left: 20px">
          <el-form-item :label="$t('user_month')" label-width="68px" class="form-label" prop="monthNumber">
            <el-input v-model.number="form.monthNumber" :disabled="formMonth" placeholder="0" @input="monthChange"
              size="mini" style="width: 70px"></el-input>
          </el-form-item>
        </div>
        <div style="float:left;margin-top: 10px;margin-left: 20px;">
          <el-form-item :label="$t('domain')" label-width="68px" class="form-label" prop="instSubDomain">
            <el-input v-model="form.instSubDomain" style="width: 140px" size="mini">
              <!-- <span slot="suffix">.somatime.com</span> -->
            </el-input>
            <span style="color: #fff;">.somatime.com</span>
          </el-form-item>
        </div>
      </el-form>
      <div slot="ProductRight" class="product-R">
        <div style="float: left; color: #fff; margin-right:15px;">
          <span class="amount-title">{{ $t('amount') + ': ' }}</span>
          <span class="amount-val">{{ amount + ' ' }}{{ itemErpProduct.currency }}</span>
        </div>
        <!-- <el-button
          round
          size="small"
          :disabled="disabledBuy"
          @click="buyClick('trial')"
          style="background-color:#409eff;border-color:#3266FF;color:#3266FF;color:#fff;"
          >{{ $t('apply_trial') }}</el-button
        > -->
        <el-button type="primary" round size="small" :disabled="disabledBuy" @click="buyClick('buy')"
          style="width: 5vw">{{ $t('buy') }}</el-button>
      </div>
    </Footerbar>
  </div>
</template>
<script>
import ListSearchToobar from '@/components/ListSearchToobar';
import Footerbar from '@/components/Footerbar';
import productApi from '@/apis/product';
import fileApi from '@/apis/file-api';
import orderApi from '@/apis/order';
import userApi from '@/apis/user';
import { mapMutations } from 'vuex';

export default {
  name: 'ProductList',
  data() {
    var checkNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('required')));
        return;
      }
      if (!Number.isInteger(value)) {
        callback(new Error(this.$t('requied_num')));
        return;
      }
      if (!this.$formValidation.intreg.test(value)) {
        callback(new Error(this.$t('format_error')));
        return;
      }
      if (value < 0 || value > 9999999999999.99) {
        callback(new Error(this.$t('format_error')));
        return;
      }
      callback();
    };

    var checkDomain = (rule, value, callback) => {
      // debugger;
      if (value === '') {
        callback(new Error(this.$t('required')));
      } else {
        if (!this.$formValidation.doMainReg.test(value)) {
          callback(new Error(this.$t('format_error')));
        }
        callback();
      }
    };
    return {
      screenWidth: 0,
      screenHeight: 0,
      leftHeight: 0,
      pageHeight: 0,
      pageWidth: 0,
      infoWidth: 0,
      productId: '',
      searchToobarData: {
        showBarRight: false,
        floatRight: true,
        iconName: 'icon-product',
        componentName: this.$t('product_list')
      },
      imgFile: {
        dataUrl: '',
        name: ''
      },
      disabled: false,
      ProductList: [],
      tableHeight: 0,
      dialogVisible: false,
      readonly: false,
      dialogStatus: '',
      textMap: {
        create: 'New Product',
        update: 'Modify Product'
      },
      form: {
        productId: '',
        email: '',
        firstName: '',
        lastName: '',
        cellphone: '',
        company: '',
        userNumber: '',
        monthNumber: '',
        creationMethod: '',
        groupName: '',
        currency: '',
        countryCode: '',
        legalPerson: '',
        telephone: '',
        address: '',
        buyer: '',
        instSubDomain: ''
      },
      rowlist: {},
      searchRquest: {
        draft: false,
        onshelf: false,
        offshelf: false
      },
      loading: false,
      ArrayStatus: [],
      active: 0,
      erpProductIcon: '',
      itemErpProduct: {},
      ShowActive: false,
      amount: 0,
      formMonth: false,
      disabledBuy: true,
      photoId: '',
      photoArray: [],
      paymentValueOption: [
        {
          value: 10,
          label: this.$t('one_time_payment')
        },
        {
          value: 20,
          label: this.$t('subscribe')
        }
      ],
      rules: {
        firstName: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],
        lastName: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],
        userNumber: [
          { validator: checkNumber, trigger: 'blur' },
          {
            required: true,
            message: 'UserQty is required',
            trigger: 'blur'
          }
        ],
        monthNumber: [
          { validator: checkNumber, trigger: 'blur' },
          {
            required: true,
            message: 'Month is required',
            trigger: 'blur'
          }
        ],
        creationMethod: [
          {
            required: true,
            trigger: 'blur'
          }
        ],
        instSubDomain: [
          {
            required: true,
            validator: checkDomain,
            trigger: 'blur'
          }
        ]
      }
    };
  },

  computed: {},

  watch: {
    screenWidth: {
      immediate: true,
      handler: function (newVal) {
        setTimeout(() => {
          this.calculationSize();
        }, 100);
      }
    },
    screenHeight: {
      immediate: true,
      handler: function (newVal) {
        setTimeout(() => {
          this.calculationSize();
        }, 100);
      }
    },
    activeName: {
      immediate: true,
      handler: function (newVal) {
        setTimeout(() => {
          this.calculationSize();
        }, 100);
      }
    }
  },

  mounted() {
    this.getListData();
    this.init();
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = window.innerWidth;
        that.screenWidth = window.screenWidth;
        window.screenHeight = window.innerHeight;
        that.screenHeight = window.screenHeight;
      })();
    };
  },

  methods: {
    calculationSize() {
      const windowHeight = window.innerHeight;
      const navBarHeight = 80;
      const footerBarHeight = 60;
      this.pageHeight = windowHeight - navBarHeight - footerBarHeight;
      this.leftHeight = windowHeight - navBarHeight - footerBarHeight - 54;
      const windowWidth = window.innerWidth;
      this.pageWidth = windowWidth;
      this.infoWidth = windowWidth / 4 - 64;
    },

    init() {
      this.getUser();
      this.formMonth = false;
      this.amount = 0;
    },

    async getListData() {
      const req = {
        ...this.searchRquest
      };
      const res = await productApi.ErpProductList(req);
      if (res.list.length > 0) {
        this.ProductList = res.list;
        this.itemErpProduct = res.list[0];
        this.form.productId = res.list[0].id;
        this.productId = res.list[0].id;
        this.getPhotoId();
      }
    },

    ProductListClick(item, index) {
      this.itemErpProduct = { ...item };
      this.productId = item.id;
      this.active = index;
      this.getCalculate();
    },

    showPover() {
      this.ShowActive = true;
    },

    hidePover() {
      this.ShowActive = false;
    },

    getPhotoId() {
      this.ProductList.forEach((item, index) => {
        this.getImg(item, index);
      });
    },

    async getImg(data, index) {
      const imgReq = {
        id: data.photo
      };
      const imgRes = await fileApi.getImageDataUrl(imgReq);
      this.$set(this.ProductList[index], 'dataUrl', imgRes);
    },

    async getUser() {
      const req = {};
      const res = await userApi.getUserInfo(req);
      this.form = { ...this.form, ...res };
      this.form.telephone = res.cellphone;
      this.form.id = '';
      this.SET_USERINFO(res);
      if (res.type === 10) {
        this.disabled = true;
      }
    },

    async getCalculate() {
      this.form.productId = this.productId;
      const req = {
        productId: this.itemErpProduct.id,
        userNumber: this.form.userNumber,
        monthNumber: this.form.monthNumber
      };
      const res = await orderApi.calculate(req);
      this.amount = res.payableAmount;
      // console.log(this.amount);
    },

    userqtyChange() {
      this.getCalculate();
    },

    monthChange() {
      this.getCalculate();
    },

    trialButtonClick() {
      this.$confirm(
        '<div><div class="el-message-box__message" style="margin:20px 0 40px;"><p style="font-size:16px;">' + this.$t('domain_info') + '</p><p style="margin:20px 10px;"><input id="domainName" style="" class="el-input__inner domain-class" type="text" />.somatime.com</p></div></div>', this.$t('apply_trial'),
        {
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          roundButton: true,
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              const domainName = document.getElementById('domainName').value;
              if (domainName) {
                this.form.instSubDomain = domainName;
                instance.confirmButtonLoading = true; // 开启按钮加载状态
                instance.confirmButtonText = this.$t('confirm') + '...';
                // *****************************开始
                this.form.telephone = this.form.cellphone;
                this.form.buyer = this.form.firstName + ' ' + this.form.lastName;
                const req = {
                  ...this.form
                };
                // 添加试用参数
                req.isTrial = true;
                req.monthNumber = 1;
                req.userNumber = 10;
                req.creationMethod = 10;
                req.currency = '';
                orderApi.purchaseCreate(req).then(res => {
                  if (res.succeeded) {
                    instance.confirmButtonLoading = false; // 开启按钮加载状态
                    instance.confirmButtonText = this.$t('confirm');
                    done();
                    this.form.instSubDomain = '';
                    setTimeout(() => {
                      this.getTrialSuccess();
                    }, 500);
                  } else if (res.reason === 3) {
                    this.$message({
                      message: this.$t('domain_in_use'),
                      type: 'error'
                    });
                    this.init();
                  }
                }).catch(err => {
                  console.log('purchaseCreate err:', err);
                }).finally(
                  () => {
                    instance.confirmButtonLoading = false; // 开启按钮加载状态
                    instance.confirmButtonText = this.$t('confirm');
                  }
                );
                // *****************************结束
              } else {
                this.$message({
                  message: this.$t('please_fill_in_domain_info'),
                  type: 'error',
                  duration: 5000
                });
              }
            } else {
              this.form.instSubDomain = '';
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = this.$t('confirm');
              done();
            }
          }
        })
        .then(() => {
          // this.getTrialPurchaseOrder();
          console.log('confirm then');
        })
        .catch((action) => {
          if (action === 'cancel') {
            // alert('取消');
          }
        });
    },

    buyClick(isTrial) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.creationMethod === 10) {
            this.getPurchaseOrder(isTrial);
          } else if (this.form.creationMethod === 20) {
            if (isTrial === 'trial') {
              this.$alert(this.$t('trial_only_allow_one_time_payment_method'), this.$t('tips'), {
                confirmButtonText: this.$t('confirm'),
                callback: action => { }
              });
            } else {
              this.getSubscriptOrder(isTrial);
            }
          }
          // this.init();
        } else {
          this.$message({
            message: this.$t('require_tips'),
            type: 'warning',
            duration: 5000
          });
        }
      });
    },

    async getPurchaseOrder(isTrial) {
      this.form.telephone = this.form.cellphone;
      // this.form.buyer = this.form.firstName + '\xa0' + this.form.lastName;
      this.form.buyer = this.form.firstName + ' ' + this.form.lastName;
      const req = {
        ...this.form
      };
      // 添加试用参数
      if (isTrial === 'trial') {
        req.isTrial = true;
      } else {
        req.isTrial = false;
      }
      const res = await orderApi.purchaseCreate(req);
      if (res.succeeded) {
        const msg = isTrial === 'trial' ? this.$t('requesting_a_trial') : this.$t('purchase_success');
        this.$alert(msg, this.$t('tips'), {
          confirmButtonText: this.$t('confirm'),
          callback: action => {
            this.init();
            this.$router.push({ name: 'OrderList' });
            this.form = {
              productId: '',
              // nickname: '',
              firstName: '',
              lastName: '',
              email: '',
              cellphone: '',
              company: '',
              userNumber: '',
              monthNumber: '',
              creationMethod: '',
              groupName: '',
              currency: '',
              countryCode: '',
              legalPerson: '',
              telephone: '',
              address: '',
              buyer: '',
              instSubDomain: ''
            };
          }
        });
      } else if (res.reason === 3) {
        this.$message({
          message: this.$t('domain_in_use'),
          type: 'error',
          duration: 5000
        });
        this.init();
      }
    },

    async getSubscriptOrder(isTrial) {
      this.form.telephone = this.form.cellphone;
      // this.form.buyer = this.form.firstName + '\xa0' + this.form.lastName;
      this.form.buyer = this.form.firstName + ' ' + this.form.lastName;
      const req = {
        ...this.form
      };
      // 添加试用参数
      if (isTrial === 'trial') {
        req.isTrial = true;
      } else {
        req.isTrial = false;
      }
      const res = await orderApi.subscriptCreate(req);
      if (res.succeeded) {
        const msg = isTrial === 'trial' ? this.$t('requesting_a_trial') : this.$t('subscript_success');
        this.$alert(msg, this.$t('tips'), {
          confirmButtonText: this.$t('confirm'),
          callback: action => {
            this.init();
            this.$router.push({ name: 'OrderList' });
            this.form = {
              productId: '',
              // nickname: '',
              firstName: '',
              lastName: '',
              email: '',
              cellphone: '',
              company: '',
              userNumber: '',
              monthNumber: '',
              creationMethod: '',
              groupName: '',
              currency: '',
              countryCode: '',
              legalPerson: '',
              telephone: '',
              address: '',
              buyer: '',
              instSubDomain: ''
            };
          }
        });
      } else if (res.reason === 3) {
        this.$message({
          message: this.$t('domain_in_use'),
          type: 'error',
          duration: 5000
        });
        this.init();
      }
    },
    // 产品的申请试用-成功后的处理
    getTrialSuccess() {
      this.$alert(this.$t('requesting_a_trial'), this.$t('tips'), {
        confirmButtonText: this.$t('confirm'),
        callback: action => {
          this.init();
          this.$router.push({ name: 'OrderList' });
          this.form = {
            productId: '',
            // nickname: '',
            firstName: '',
            lastName: '',
            email: '',
            cellphone: '',
            company: '',
            userNumber: '',
            monthNumber: '',
            creationMethod: '',
            groupName: '',
            currency: '',
            countryCode: '',
            legalPerson: '',
            telephone: '',
            address: '',
            buyer: '',
            instSubDomain: ''
          };
        }
      });
    },

    // 产品的申请试用 - 暂不使用
    async getTrialPurchaseOrder() {
      this.form.telephone = this.form.cellphone;
      // this.form.buyer = this.form.firstName + '\xa0' + this.form.lastName;
      this.form.buyer = this.form.firstName + ' ' + this.form.lastName;
      const req = {
        ...this.form
      };
      // 添加试用参数
      req.isTrial = true;
      req.monthNumber = 1;
      req.userNumber = 10;
      req.creationMethod = 10;
      req.currency = '';
      const res = await orderApi.purchaseCreate(req);
      if (res.succeeded) {
        this.$alert(this.$t('requesting_a_trial'), this.$t('tips'), {
          confirmButtonText: this.$t('confirm'),
          callback: action => {
            this.init();
            this.$router.push({ name: 'OrderList' });
            this.form = {
              productId: '',
              // nickname: '',
              firstName: '',
              lastName: '',
              email: '',
              cellphone: '',
              company: '',
              userNumber: '',
              monthNumber: '',
              creationMethod: '',
              groupName: '',
              currency: '',
              countryCode: '',
              legalPerson: '',
              telephone: '',
              address: '',
              buyer: '',
              instSubDomain: ''
            };
          }
        });
      } else if (res.reason === 3) {
        this.$message({
          message: this.$t('domain_in_use'),
          type: 'error',
          duration: 5000
        });
        this.init();
      }
    },

    creationMethodChange(val) {
      if (val === 10) {
        this.formMonth = false;
      } else {
        this.form.monthNumber = 1;
        this.formMonth = true;
      }
      this.disabledBuy = false;
      this.getCalculate();
    },

    ...mapMutations(['SET_USERINFO'])
  },

  components: {
    ListSearchToobar,
    Footerbar
  }
};
</script>

<style lang="scss" scoped>
@import 'iceqerp-common/style/basic-theme-data.scss';

.isActive {
  border: 1px solid #0a0aff;
  border-radius: 4px;
}

.product_list {
  overflow-y: auto;
  padding-left: 21px;

  ul {
    text-align: left;
  }

  li {
    display: inline-block;
    width: 320px;
    height: 400px;
    background: #fff;
    border-radius: 4px;
    margin-right: 10%;
    padding: 30px;
    margin-bottom: 54px;
    // margin-top: 50px;
  }
}

.erp_product_name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
  font-weight: bold;
  color: #292929;
  margin-bottom: 10px;
}

.erp_product_amount {
  font-size: 16px;
  color: #292929;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.erp_product_img {
  width: max-content;
  margin: 20px auto 125px;
}

.erpProductIcon {
  width: 86px;
  height: 136px;
  background: #3266ff;
}

.product-right {
  background: #ffffff;

  ul {
    list-style: none;
    text-align: left;
    padding: 35px 24px 0 40px;
  }

  li {
    border-bottom: 1px solid #f4f4f4;
  }
}

.item-code {
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  color: #292929;
  line-height: 24px;
}

.item-val {
  font-size: 14px;
  color: #292929;
  float: right;
  line-height: 24px;
}

.item-name {
  display: inline-block;
  font-size: 24px;
  font-weight: 700;
  color: $themeBlue;
}

.item-descriptioninfo {
  word-break: normal;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
  font-size: 14px;
  float: left;
  color: #666666;
}

.buyer-info {
  .input-theme {
    background-color: #ffffff;
    // border: 1px solid #292929;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  .el-form-item__label {
    font-weight: bold;
    color: #292929;
  }
}

.popover-but.el-button {
  background-color: #292929 !important;
  color: #fff;
  border: none;
}

.amount-val {
  font-size: 20px;
  font-weight: 700;
  margin-right: 4px;
}

.product-R {
  margin-right: 20px;
}
</style>

<style lang="scss">
.form-label {
  .el-form-item__label {
    color: #fff;
  }

  .el-form-item__error {
    line-height: 0;
    padding-top: 1px;
    text-align: left;
  }
}

.product-img {
  width: 100%;
  height: 280px;
  object-fit: fill;
  object-fit: contain;
  object-fit: scale-down;
}

.body {
  height: 100%;
  overflow: hidden;
  min-width: 1366px;
}
</style>

<style>
.buyer-info {
  background-color: #f4f4f4;
}

.trial-button {
  /* position: absolute;
  right: 10px;
  bottom: 24px; */
  font-size: 13px;
  line-height: 14px;
  padding: 10px 2px;
  /* min-width: 56px; */
  background-color: #409eff !important;
  border-color: #409eff !important;
  color: #fff;
  box-shadow: none;
}

.el-button--primary.trial-button:hover,
.el-button--primary.trial-button:focus {
  color: #fff;
  background-color: #409EFF !important;
  border-color: #409EFF !important;
  box-shadow: none;
  opacity: 0.7;
}

.domain-class {
  display: inline-block;
  width: 180px;
  border: 1px solid #DCDFE6 !important;
}
</style>
